import axios from 'axios'

import { AXIOS_DEFAULT_CONFIG, AXIOS_DEFAULT_CONFIG_ERP } from '@/config'
import { requestSuccessFunc, requestFailFunc, responseSuccessFunc, responseFailFunc } from '@/config/interceptors'
import {
  requestFailFuncErp, requestSuccessFuncErp, responseFailFuncErp, responseSuccessFuncErp,
} from '@/config/interceptors/axiosErp'

// 注入默认配置
const axiosInstance = axios.create(AXIOS_DEFAULT_CONFIG)

axiosInstance.interceptors.request.use(requestSuccessFunc, requestFailFunc)
axiosInstance.interceptors.response.use(responseSuccessFunc, responseFailFunc)

export const axiosErp = axios.create(AXIOS_DEFAULT_CONFIG_ERP)
axiosErp.interceptors.request.use(requestSuccessFuncErp, requestFailFuncErp)
axiosErp.interceptors.response.use(responseSuccessFuncErp, responseFailFuncErp)

export default axiosInstance
